<template>
  <div class="version-description">
    <p class="d-title">更新说明</p>
    <p class="d-desc" v-html="desc || '无'"></p>
  </div>
</template>

<script>
export default {
  props: {
    desc: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/mixins.scss";
.version-description {
  padding: 50px 20px;
  @include onepx-border-bottom(#dcdfe6);
  .d-title {
    font-size: 21px;
    margin-bottom: 20px;
  }
}
</style>
